<template>
  <b-alert v-model="show" :variant="variant" dismissible @dismissed='resetAlert' class="position-fixed fixed-top m-2 rounded-1" style="z-index: 9999;">
    {{ message }}
  </b-alert>
</template>

<script>
function initialDataAlert () {
  return {
    show: false,
    variant: 'success',
    message: ''
  }
}
export default {
  name: 'Alert',
  mixins: [],
  props: {},
  components: {},
  data () {
    return initialDataAlert()
  },
  methods: {
    resetAlert () {
      Object.assign(this.$data, initialDataAlert())
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.$root.$on('showAlert', (variant, message, sec = 5) => {
      this.show = sec
      this.variant = variant
      this.message = message
    })
  },
  beforeDestroy () {
  },
  destroyed() {
    this.$root.$off('showAlert')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
